import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardMedia from '@material-ui/core/CardMedia'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone'
import React, { useContext, useRef } from 'react'
import Slider, { Settings } from 'react-slick'

import colorContext from '../../../../Context/colorContext'
import { Applications } from '../../types/get.applications'
import stylesAppsHome from './stylesAppsHome'
import useApps from './useApps'

interface Props {
  listApps: Applications
}

export default function Apps({ listApps }: Props): JSX.Element {
  const { colors } = useContext(colorContext)
  const sliderRef = useRef<Slider | null>(null)
  const matches = useMediaQuery('(max-width:1250px)')
  const matchesMobile = useMediaQuery('(max-width:660px)')
  const classes = stylesAppsHome({ colors, matchesMobile, matches })
  const { appSelected, handleShowMoreApps, setAppSelected } = useApps(listApps)

  const NextArrow = (): JSX.Element => (
    <IconButton
      className={classes.IconNavite}
      onClick={() => sliderRef.current.slickNext()}
    >
      <NavigateNextIcon className={classes.icon} />
    </IconButton>
  )
  const PrevArrow = (): JSX.Element => (
    <IconButton
      className={classes.IconNavite}
      onClick={() => sliderRef.current.slickPrev()}
    >
      <NavigateBeforeIcon className={classes.icon} />
    </IconButton>
  )

  const settings: Settings = {
    speed: 1000,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          infinite: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
        },
      },
    ],
  }
  return (
    <Box className={classes.main}>
      <Box
        display="flex"
        maxWidth="1320px"
        width="100%"
        flexDirection="column"
        style={{
          gap: 60,
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          flexDirection={matches ? 'column' : 'row'}
          style={{
            gap: 22,
          }}
        >
          <Typography className={classes.textTitle} variant="h5">
            <PhoneIphoneIcon fontSize={matchesMobile ? 'default' : 'large'} />
            APPs ÚTEIS
          </Typography>
        </Box>
        {handleShowMoreApps() ? (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexWrap="wrap"
          >
            {listApps.results.map((app) => (
              <Card
                onMouseEnter={() => setAppSelected(app?.id)}
                onMouseLeave={() => setAppSelected(null)}
                key={app?.id}
                className={classes.card}
              >
                <Box
                  position="absolute"
                  height="100%"
                  width="100%"
                  display={appSelected === app?.id ? 'flex' : 'none'}
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="space-around"
                  zIndex="1"
                  style={{
                    background: colors.cardAccentColor,
                  }}
                >
                  <Typography
                    style={{
                      color: colors.textAccentColor,
                      textTransform: 'none',
                      fontSize: 14,
                    }}
                    align="center"
                  >
                    {app?.nome}
                  </Typography>
                  <Box display="flex" flexDirection="column">
                    <Button
                      onClick={() => window.open(app?.url_apple)}
                      className={classes.button}
                      style={{ display: app?.url_apple ? 'block' : 'none' }}
                      variant="outlined"
                    >
                      App Store
                    </Button>
                    <Button
                      onClick={() => window.open(app?.url_google)}
                      className={classes.button}
                      style={{ display: app?.url_google ? 'block' : 'none' }}
                      variant="outlined"
                    >
                      Google Play
                    </Button>
                  </Box>
                </Box>
                <CardActionArea
                  style={{
                    height: '100%',
                  }}
                >
                  <CardMedia
                    style={{
                      height: '100%',
                    }}
                    image={app?.url_logo}
                  />
                </CardActionArea>
              </Card>
            ))}
          </Box>
        ) : (
          <Box>
            <Slider {...settings} ref={sliderRef} className={classes.slider}>
              {listApps.results.map((app) => (
                <Box
                  key={app?.id}
                  display={!handleShowMoreApps() ? 'flex !important' : ''}
                  alignItems="center"
                  flexDirection="column"
                >
                  <Card
                    onMouseEnter={() => setAppSelected(app?.id)}
                    onMouseLeave={() => setAppSelected(null)}
                    key={app?.id}
                    className={classes.card}
                  >
                    <Box
                      position="absolute"
                      height="100%"
                      width="100%"
                      display={appSelected === app?.id ? 'flex' : 'none'}
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="space-around"
                      zIndex="1"
                      padding="10px"
                      className={classes.boxCover}
                    >
                      <Typography
                        style={{
                          color: colors.textAccentColor,
                          textTransform: 'none',
                          fontSize: matchesMobile ? 12 : 14,
                          fontWeight: 'bold',
                          maxWidth: 100,
                        }}
                        align="center"
                      >
                        {app?.nome}
                      </Typography>
                      <Box display="flex" flexDirection="column">
                        <Button
                          // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                          onClick={() => window.open(app?.url_apple)}
                          className={classes.button}
                          style={{ display: app?.url_apple ? 'block' : 'none' }}
                          variant="outlined"
                        >
                          App Store
                        </Button>
                        <Button
                          // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                          onClick={() => window.open(app?.url_google)}
                          className={classes.button}
                          style={{
                            display: app?.url_google ? 'block' : 'none',
                          }}
                          variant="outlined"
                        >
                          Google Play
                        </Button>
                      </Box>
                    </Box>
                    <CardActionArea
                      style={{
                        height: '100%',
                      }}
                    >
                      <CardMedia
                        style={{
                          height: '100%',
                        }}
                        image={app?.url_logo}
                      />
                    </CardActionArea>
                  </Card>
                </Box>
              ))}
            </Slider>
          </Box>
        )}
      </Box>
    </Box>
  )
}
